import styled from '@emotion/styled'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import Container from '../../components/global/Container'
import Section from '../../components/global/Section'
import Title from '../../components/global/Title'

const Contact = () => {
    const { t } = useTranslation('translation')

    return (
        <Container>
            <Section>
                <Title>{t('page.contact.title')}</Title>
                <ContactInfoContainer>
                    <InfoContainer>
                        <FontAwesomeIcon icon={faEnvelope} />
                        <InfoItem>contact@bva-club.fr</InfoItem>
                    </InfoContainer>
                    <InfoContainer>
                        <FontAwesomeIcon icon={faPhone} />
                        <TelWrapper>
                            Président :&nbsp; <InfoItem>07 60 13 34 35</InfoItem>
                        </TelWrapper>
                        <TelWrapper>
                            Responsable jeunes :&nbsp; <InfoItem>06 99 81 02 06</InfoItem>
                        </TelWrapper>
                    </InfoContainer>
                </ContactInfoContainer>
            </Section>
        </Container>
    )
}

const TelWrapper = styled.div`
    display: flex;
`

const ContactInfoContainer = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: calc(100vh - 338px);
`

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 250px;

    & div {
        font-family: 'Roboto Semi Bold';
        color: var(--primary-color);
        font-size: 22px;
        margin-bottom: 8px;
    }

    & .fa-envelope,
    & .fa-phone {
        color: var(--primary-color);
        font-size: 62px;
        margin-bottom: 16px;
    }
`

const InfoItem = styled.div`
    font-family: 'Roboto Semi Bold';
    color: black !important;
`

export default Contact
